import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c8385ab2 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _b11ea9c4 = () => interopDefault(import('..\\pages\\article\\index.vue' /* webpackChunkName: "pages/article/index" */))
const _ae21d856 = () => interopDefault(import('..\\pages\\business-insight\\index.vue' /* webpackChunkName: "pages/business-insight/index" */))
const _1521b074 = () => interopDefault(import('..\\pages\\clientStartPage.vue' /* webpackChunkName: "pages/clientStartPage" */))
const _abbc0884 = () => interopDefault(import('..\\pages\\deal-nav\\index.vue' /* webpackChunkName: "pages/deal-nav/index" */))
const _78540109 = () => interopDefault(import('..\\pages\\dishonestyRoster\\index.vue' /* webpackChunkName: "pages/dishonestyRoster/index" */))
const _7a9bdd45 = () => interopDefault(import('..\\pages\\document\\index.vue' /* webpackChunkName: "pages/document/index" */))
const _71330339 = () => interopDefault(import('..\\pages\\everydayQuestion\\index.vue' /* webpackChunkName: "pages/everydayQuestion/index" */))
const _146b1708 = () => interopDefault(import('..\\pages\\focus\\index.vue' /* webpackChunkName: "pages/focus/index" */))
const _65841112 = () => interopDefault(import('..\\pages\\intelQueAnswer\\index.vue' /* webpackChunkName: "pages/intelQueAnswer/index" */))
const _052d938e = () => interopDefault(import('..\\pages\\library\\index.vue' /* webpackChunkName: "pages/library/index" */))
const _7210454b = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _3ba73e9a = () => interopDefault(import('..\\pages\\msg\\index.vue' /* webpackChunkName: "pages/msg/index" */))
const _7768ace8 = () => interopDefault(import('..\\pages\\notice\\index.vue' /* webpackChunkName: "pages/notice/index" */))
const _0fa341ae = () => interopDefault(import('..\\pages\\notice-detail\\index.vue' /* webpackChunkName: "pages/notice-detail/index" */))
const _1e5d83fa = () => interopDefault(import('..\\pages\\polymerize\\index.vue' /* webpackChunkName: "pages/polymerize/index" */))
const _4227275d = () => interopDefault(import('..\\pages\\punishmentCase\\index.vue' /* webpackChunkName: "pages/punishmentCase/index" */))
const _1ffb5db0 = () => interopDefault(import('..\\pages\\qa\\index.vue' /* webpackChunkName: "pages/qa/index" */))
const _e80945d0 = () => interopDefault(import('..\\pages\\recommend\\index.vue' /* webpackChunkName: "pages/recommend/index" */))
const _d0c107d0 = () => interopDefault(import('..\\pages\\search\\index.vue' /* webpackChunkName: "pages/search/index" */))
const _20e41663 = () => interopDefault(import('..\\pages\\standard\\index.vue' /* webpackChunkName: "pages/standard/index" */))
const _aea13ef4 = () => interopDefault(import('..\\pages\\template\\index.vue' /* webpackChunkName: "pages/template/index" */))
const _62aabe0e = () => interopDefault(import('..\\pages\\video\\index.vue' /* webpackChunkName: "pages/video/index" */))
const _6ac6472e = () => interopDefault(import('..\\pages\\viewpoint\\index.vue' /* webpackChunkName: "pages/viewpoint/index" */))
const _301a9966 = () => interopDefault(import('..\\pages\\windowsClient\\index.vue' /* webpackChunkName: "pages/windowsClient/index" */))
const _4a08c10e = () => interopDefault(import('..\\pages\\businessIntelligence\\agent\\index.vue' /* webpackChunkName: "pages/businessIntelligence/agent/index" */))
const _1fca4750 = () => interopDefault(import('..\\pages\\businessIntelligence\\candidate\\index.vue' /* webpackChunkName: "pages/businessIntelligence/candidate/index" */))
const _2ebf1aa8 = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\index.vue' /* webpackChunkName: "pages/businessIntelligence/invest/index" */))
const _b2f52326 = () => interopDefault(import('..\\pages\\businessIntelligence\\tender\\index.vue' /* webpackChunkName: "pages/businessIntelligence/tender/index" */))
const _3ae5c7b8 = () => interopDefault(import('..\\pages\\businessIntelligence\\thematic\\index.vue' /* webpackChunkName: "pages/businessIntelligence/thematic/index" */))
const _5c48f7ec = () => interopDefault(import('..\\pages\\deal-nav\\bid-review.vue' /* webpackChunkName: "pages/deal-nav/bid-review" */))
const _7b55f828 = () => interopDefault(import('..\\pages\\deal-nav\\cabl.vue' /* webpackChunkName: "pages/deal-nav/cabl" */))
const _380c8861 = () => interopDefault(import('..\\pages\\deal-nav\\calculter.vue' /* webpackChunkName: "pages/deal-nav/calculter" */))
const _3a08f6b6 = () => interopDefault(import('..\\pages\\deal-nav\\calculterOld.vue' /* webpackChunkName: "pages/deal-nav/calculterOld" */))
const _8e9f95de = () => interopDefault(import('..\\pages\\deal-nav\\jyzx.vue' /* webpackChunkName: "pages/deal-nav/jyzx" */))
const _9b7c147a = () => interopDefault(import('..\\pages\\deal-nav\\purchase-files-generate.vue' /* webpackChunkName: "pages/deal-nav/purchase-files-generate" */))
const _913ff45a = () => interopDefault(import('..\\pages\\deal-nav\\third.vue' /* webpackChunkName: "pages/deal-nav/third" */))
const _1b48d29d = () => interopDefault(import('..\\pages\\everydayQuestion\\questionInfo.vue' /* webpackChunkName: "pages/everydayQuestion/questionInfo" */))
const _19915fc4 = () => interopDefault(import('..\\pages\\externalplatform\\maxkeyLogin.vue' /* webpackChunkName: "pages/externalplatform/maxkeyLogin" */))
const _2a85a95e = () => interopDefault(import('..\\pages\\intelQueAnswer\\indexback.vue' /* webpackChunkName: "pages/intelQueAnswer/indexback" */))
const _3038605c = () => interopDefault(import('..\\pages\\library\\documentInfo.vue' /* webpackChunkName: "pages/library/documentInfo" */))
const _c9de5854 = () => interopDefault(import('..\\pages\\punishmentCase\\detail.vue' /* webpackChunkName: "pages/punishmentCase/detail" */))
const _0c334e46 = () => interopDefault(import('..\\pages\\search\\article\\index.vue' /* webpackChunkName: "pages/search/article/index" */))
const _a3a4c1c6 = () => interopDefault(import('..\\pages\\search\\document\\index.vue' /* webpackChunkName: "pages/search/document/index" */))
const _65cd3cf0 = () => interopDefault(import('..\\pages\\search\\qa\\index.vue' /* webpackChunkName: "pages/search/qa/index" */))
const _b2e823be = () => interopDefault(import('..\\pages\\search\\video\\index.vue' /* webpackChunkName: "pages/search/video/index" */))
const _09435591 = () => interopDefault(import('..\\pages\\search\\viewpoint\\index.vue' /* webpackChunkName: "pages/search/viewpoint/index" */))
const _492912d2 = () => interopDefault(import('..\\pages\\user\\answer\\index.vue' /* webpackChunkName: "pages/user/answer/index" */))
const _630ba5b2 = () => interopDefault(import('..\\pages\\user\\assets\\index.vue' /* webpackChunkName: "pages/user/assets/index" */))
const _d889ca96 = () => interopDefault(import('..\\pages\\user\\collect\\index.vue' /* webpackChunkName: "pages/user/collect/index" */))
const _0ec9aa60 = () => interopDefault(import('..\\pages\\user\\comment\\index.vue' /* webpackChunkName: "pages/user/comment/index" */))
const _1d52e666 = () => interopDefault(import('..\\pages\\user\\download\\index.vue' /* webpackChunkName: "pages/user/download/index" */))
const _7341310b = () => interopDefault(import('..\\pages\\user\\history\\index.vue' /* webpackChunkName: "pages/user/history/index" */))
const _79f47fb8 = () => interopDefault(import('..\\pages\\user\\message\\index.vue' /* webpackChunkName: "pages/user/message/index" */))
const _47b4815e = () => interopDefault(import('..\\pages\\user\\order\\index.vue' /* webpackChunkName: "pages/user/order/index" */))
const _a4a8be4c = () => interopDefault(import('..\\pages\\user\\password\\index.vue' /* webpackChunkName: "pages/user/password/index" */))
const _fa64a2f6 = () => interopDefault(import('..\\pages\\user\\qa\\index.vue' /* webpackChunkName: "pages/user/qa/index" */))
const _16984c62 = () => interopDefault(import('..\\pages\\user\\setting\\index.vue' /* webpackChunkName: "pages/user/setting/index" */))
const _7151b7f8 = () => interopDefault(import('..\\pages\\user\\video\\index.vue' /* webpackChunkName: "pages/user/video/index" */))
const _782a3c18 = () => interopDefault(import('..\\pages\\user\\viewpoint\\index.vue' /* webpackChunkName: "pages/user/viewpoint/index" */))
const _c206e48c = () => interopDefault(import('..\\pages\\video\\detail.vue' /* webpackChunkName: "pages/video/detail" */))
const _06344c65 = () => interopDefault(import('..\\pages\\businessIntelligence\\agent\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/agent/Detail" */))
const _6dbb7b52 = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\CityDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/CityDetail" */))
const _33cb9cda = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\DeepDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/DeepDetail" */))
const _f0409df6 = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\IndustryDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/IndustryDetail" */))
const _394d4ae6 = () => interopDefault(import('..\\pages\\businessIntelligence\\tender\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/tender/Detail" */))
const _30f81afb = () => interopDefault(import('..\\pages\\businessIntelligence\\thematic\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/thematic/Detail" */))
const _82a3522e = () => interopDefault(import('..\\pages\\deal-nav\\config\\rate.js' /* webpackChunkName: "pages/deal-nav/config/rate" */))
const _49ecffe8 = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\deal-center-info.vue' /* webpackChunkName: "pages/deal-nav/seciton/deal-center-info" */))
const _6e9091c8 = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\main-bottom.vue' /* webpackChunkName: "pages/deal-nav/seciton/main-bottom" */))
const _181c9ef2 = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\main-center.vue' /* webpackChunkName: "pages/deal-nav/seciton/main-center" */))
const _a9752c70 = () => interopDefault(import('..\\pages\\search\\config\\nav.js' /* webpackChunkName: "pages/search/config/nav" */))
const _f93bfd0c = () => interopDefault(import('..\\pages\\search\\mixins\\main.js' /* webpackChunkName: "pages/search/mixins/main" */))
const _73cff557 = () => interopDefault(import('..\\pages\\user\\assets\\explain.vue' /* webpackChunkName: "pages/user/assets/explain" */))
const _4cb84d06 = () => interopDefault(import('..\\pages\\user\\assets\\vip.vue' /* webpackChunkName: "pages/user/assets/vip" */))
const _721022f2 = () => interopDefault(import('..\\pages\\library\\assets\\js\\news.js' /* webpackChunkName: "pages/library/assets/js/news" */))
const _40f21676 = () => interopDefault(import('..\\pages\\notice\\assets\\js\\news.js' /* webpackChunkName: "pages/notice/assets/js/news" */))
const _511abf08 = () => interopDefault(import('..\\pages\\polymerize\\assets\\js\\news.js' /* webpackChunkName: "pages/polymerize/assets/js/news" */))
const _3b4581cc = () => interopDefault(import('..\\pages\\user\\assets\\icon\\coin.vue' /* webpackChunkName: "pages/user/assets/icon/coin" */))
const _162297d9 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\score.vue' /* webpackChunkName: "pages/user/assets/icon/score" */))
const _62172456 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\ticket.vue' /* webpackChunkName: "pages/user/assets/icon/ticket" */))
const _196a2ec1 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\ticket-special.vue' /* webpackChunkName: "pages/user/assets/icon/ticket-special" */))
const _958e1e22 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\wechat.vue' /* webpackChunkName: "pages/user/assets/icon/wechat" */))
const _bdafbd00 = () => interopDefault(import('..\\pages\\user\\message\\mixins\\item.js' /* webpackChunkName: "pages/user/message/mixins/item" */))
const _2dddfc15 = () => interopDefault(import('..\\pages\\user\\message\\mixins\\list.js' /* webpackChunkName: "pages/user/message/mixins/list" */))
const _ce80ba8a = () => interopDefault(import('..\\pages\\user\\assets\\icon\\mixins\\main.js' /* webpackChunkName: "pages/user/assets/icon/mixins/main" */))
const _591947a1 = () => interopDefault(import('..\\pages\\qa\\special\\_guid.vue' /* webpackChunkName: "pages/qa/special/_guid" */))
const _753400e4 = () => interopDefault(import('..\\pages\\viewpoint\\topic\\_id.vue' /* webpackChunkName: "pages/viewpoint/topic/_id" */))
const _e2c0d298 = () => interopDefault(import('..\\pages\\article\\_guid.vue' /* webpackChunkName: "pages/article/_guid" */))
const _61cac8db = () => interopDefault(import('..\\pages\\document\\_guid.vue' /* webpackChunkName: "pages/document/_guid" */))
const _36cfbc62 = () => interopDefault(import('..\\pages\\library\\_guid.vue' /* webpackChunkName: "pages/library/_guid" */))
const _072a4946 = () => interopDefault(import('..\\pages\\qa\\_guid.vue' /* webpackChunkName: "pages/qa/_guid" */))
const _944ce6e2 = () => interopDefault(import('..\\pages\\video\\_guid.vue' /* webpackChunkName: "pages/video/_guid" */))
const _9c687002 = () => interopDefault(import('..\\pages\\viewpoint\\_guid.vue' /* webpackChunkName: "pages/viewpoint/_guid" */))
const _c8146780 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _ec5ae5b8 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\dishonesty-name.vue' /* webpackChunkName: "pages/index/compoentsNew/dishonesty-name" */))
const _e0f0a090 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\hot-new.vue' /* webpackChunkName: "pages/index/compoentsNew/hot-new" */))
const _c3815192 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\intelligent-answers.vue' /* webpackChunkName: "pages/index/compoentsNew/intelligent-answers" */))
const _211c4e47 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\latest-answers.vue' /* webpackChunkName: "pages/index/compoentsNew/latest-answers" */))
const _10658e5e = () => interopDefault(import('..\\pages\\index\\compoentsNew\\library-box.vue' /* webpackChunkName: "pages/index/compoentsNew/library-box" */))
const _a3d482f0 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\notice-publicity.vue' /* webpackChunkName: "pages/index/compoentsNew/notice-publicity" */))
const _8ef91faa = () => interopDefault(import('..\\pages\\index\\compoentsNew\\policy-regulatory.vue' /* webpackChunkName: "pages/index/compoentsNew/policy-regulatory" */))
const _45ef7162 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\popular-searches.vue' /* webpackChunkName: "pages/index/compoentsNew/popular-searches" */))
const _2e4c3dd1 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\puishment-demo.vue' /* webpackChunkName: "pages/index/compoentsNew/puishment-demo" */))
const _df3a4bea = () => interopDefault(import('..\\pages\\index\\compoentsNew\\standard-specification.vue' /* webpackChunkName: "pages/index/compoentsNew/standard-specification" */))
const _bbf213e0 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\swiper.vue' /* webpackChunkName: "pages/index/compoentsNew/swiper" */))
const _6c965eae = () => interopDefault(import('..\\pages\\index\\compoentsNew\\tool-box.vue' /* webpackChunkName: "pages/index/compoentsNew/tool-box" */))
const _83b0aede = () => interopDefault(import('..\\pages\\index\\compoentsNew\\video-box.vue' /* webpackChunkName: "pages/index/compoentsNew/video-box" */))
const _501ec150 = () => interopDefault(import('..\\pages\\index\\assets\\js\\news.js' /* webpackChunkName: "pages/index/assets/js/news" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _c8385ab2,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/article",
    component: _b11ea9c4,
    alias: "/article/index.html",
    name: "article"
  }, {
    path: "/business-insight",
    component: _ae21d856,
    alias: "/business-insight/index.html",
    name: "business-insight"
  }, {
    path: "/clientStartPage",
    component: _1521b074,
    alias: "/clientStartPage/index.html",
    name: "clientStartPage"
  }, {
    path: "/deal-nav",
    component: _abbc0884,
    alias: "/deal-nav/index.html",
    name: "deal-nav"
  }, {
    path: "/dishonestyRoster",
    component: _78540109,
    alias: "/dishonestyRoster/index.html",
    name: "dishonestyRoster"
  }, {
    path: "/document",
    component: _7a9bdd45,
    alias: "/document/index.html",
    name: "document"
  }, {
    path: "/everydayQuestion",
    component: _71330339,
    alias: "/everydayQuestion/index.html",
    name: "everydayQuestion"
  }, {
    path: "/focus",
    component: _146b1708,
    alias: "/focus/index.html",
    name: "focus"
  }, {
    path: "/intelQueAnswer",
    component: _65841112,
    alias: "/intelQueAnswer/index.html",
    name: "intelQueAnswer"
  }, {
    path: "/library",
    component: _052d938e,
    alias: "/library/index.html",
    name: "library"
  }, {
    path: "/login",
    component: _7210454b,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/msg",
    component: _3ba73e9a,
    alias: "/msg/index.html",
    name: "msg"
  }, {
    path: "/notice",
    component: _7768ace8,
    alias: "/notice/index.html",
    name: "notice"
  }, {
    path: "/notice-detail",
    component: _0fa341ae,
    alias: "/notice-detail/index.html",
    name: "notice-detail"
  }, {
    path: "/polymerize",
    component: _1e5d83fa,
    alias: "/polymerize/index.html",
    name: "polymerize"
  }, {
    path: "/punishmentCase",
    component: _4227275d,
    alias: "/punishmentCase/index.html",
    name: "punishmentCase"
  }, {
    path: "/qa",
    component: _1ffb5db0,
    alias: "/qa/index.html",
    name: "qa"
  }, {
    path: "/recommend",
    component: _e80945d0,
    alias: "/recommend/index.html",
    name: "recommend"
  }, {
    path: "/search",
    component: _d0c107d0,
    alias: "/search/index.html",
    name: "search"
  }, {
    path: "/standard",
    component: _20e41663,
    alias: "/standard/index.html",
    name: "standard"
  }, {
    path: "/template",
    component: _aea13ef4,
    alias: "/template/index.html",
    name: "template"
  }, {
    path: "/video",
    component: _62aabe0e,
    alias: "/video/index.html",
    name: "video"
  }, {
    path: "/viewpoint",
    component: _6ac6472e,
    alias: "/viewpoint/index.html",
    name: "viewpoint"
  }, {
    path: "/windowsClient",
    component: _301a9966,
    alias: "/windowsClient/index.html",
    name: "windowsClient"
  }, {
    path: "/businessIntelligence/agent",
    component: _4a08c10e,
    alias: "/businessIntelligence/agent/index.html",
    name: "businessIntelligence-agent"
  }, {
    path: "/businessIntelligence/candidate",
    component: _1fca4750,
    alias: "/businessIntelligence/candidate/index.html",
    name: "businessIntelligence-candidate"
  }, {
    path: "/businessIntelligence/invest",
    component: _2ebf1aa8,
    alias: "/businessIntelligence/invest/index.html",
    name: "businessIntelligence-invest"
  }, {
    path: "/businessIntelligence/tender",
    component: _b2f52326,
    alias: "/businessIntelligence/tender/index.html",
    name: "businessIntelligence-tender"
  }, {
    path: "/businessIntelligence/thematic",
    component: _3ae5c7b8,
    alias: "/businessIntelligence/thematic/index.html",
    name: "businessIntelligence-thematic"
  }, {
    path: "/deal-nav/bid-review",
    component: _5c48f7ec,
    alias: "/deal-nav/bid-review/index.html",
    name: "deal-nav-bid-review"
  }, {
    path: "/deal-nav/cabl",
    component: _7b55f828,
    alias: "/deal-nav/cabl/index.html",
    name: "deal-nav-cabl"
  }, {
    path: "/deal-nav/calculter",
    component: _380c8861,
    alias: "/deal-nav/calculter/index.html",
    name: "deal-nav-calculter"
  }, {
    path: "/deal-nav/calculterOld",
    component: _3a08f6b6,
    alias: "/deal-nav/calculterOld/index.html",
    name: "deal-nav-calculterOld"
  }, {
    path: "/deal-nav/jyzx",
    component: _8e9f95de,
    alias: "/deal-nav/jyzx/index.html",
    name: "deal-nav-jyzx"
  }, {
    path: "/deal-nav/purchase-files-generate",
    component: _9b7c147a,
    alias: "/deal-nav/purchase-files-generate/index.html",
    name: "deal-nav-purchase-files-generate"
  }, {
    path: "/deal-nav/third",
    component: _913ff45a,
    alias: "/deal-nav/third/index.html",
    name: "deal-nav-third"
  }, {
    path: "/everydayQuestion/questionInfo",
    component: _1b48d29d,
    alias: "/everydayQuestion/questionInfo/index.html",
    name: "everydayQuestion-questionInfo"
  }, {
    path: "/externalplatform/maxkeyLogin",
    component: _19915fc4,
    alias: "/externalplatform/maxkeyLogin/index.html",
    name: "externalplatform-maxkeyLogin"
  }, {
    path: "/intelQueAnswer/indexback",
    component: _2a85a95e,
    alias: "/intelQueAnswer/indexback/index.html",
    name: "intelQueAnswer-indexback"
  }, {
    path: "/library/documentInfo",
    component: _3038605c,
    alias: "/library/documentInfo/index.html",
    name: "library-documentInfo"
  }, {
    path: "/punishmentCase/detail",
    component: _c9de5854,
    alias: "/punishmentCase/detail/index.html",
    name: "punishmentCase-detail"
  }, {
    path: "/search/article",
    component: _0c334e46,
    alias: "/search/article/index.html",
    name: "search-article"
  }, {
    path: "/search/document",
    component: _a3a4c1c6,
    alias: "/search/document/index.html",
    name: "search-document"
  }, {
    path: "/search/qa",
    component: _65cd3cf0,
    alias: "/search/qa/index.html",
    name: "search-qa"
  }, {
    path: "/search/video",
    component: _b2e823be,
    alias: "/search/video/index.html",
    name: "search-video"
  }, {
    path: "/search/viewpoint",
    component: _09435591,
    alias: "/search/viewpoint/index.html",
    name: "search-viewpoint"
  }, {
    path: "/user/answer",
    component: _492912d2,
    alias: "/user/answer/index.html",
    name: "user-answer"
  }, {
    path: "/user/assets",
    component: _630ba5b2,
    alias: "/user/assets/index.html",
    name: "user-assets"
  }, {
    path: "/user/collect",
    component: _d889ca96,
    alias: "/user/collect/index.html",
    name: "user-collect"
  }, {
    path: "/user/comment",
    component: _0ec9aa60,
    alias: "/user/comment/index.html",
    name: "user-comment"
  }, {
    path: "/user/download",
    component: _1d52e666,
    alias: "/user/download/index.html",
    name: "user-download"
  }, {
    path: "/user/history",
    component: _7341310b,
    alias: "/user/history/index.html",
    name: "user-history"
  }, {
    path: "/user/message",
    component: _79f47fb8,
    alias: "/user/message/index.html",
    name: "user-message"
  }, {
    path: "/user/order",
    component: _47b4815e,
    alias: "/user/order/index.html",
    name: "user-order"
  }, {
    path: "/user/password",
    component: _a4a8be4c,
    alias: "/user/password/index.html",
    name: "user-password"
  }, {
    path: "/user/qa",
    component: _fa64a2f6,
    alias: "/user/qa/index.html",
    name: "user-qa"
  }, {
    path: "/user/setting",
    component: _16984c62,
    alias: "/user/setting/index.html",
    name: "user-setting"
  }, {
    path: "/user/video",
    component: _7151b7f8,
    alias: "/user/video/index.html",
    name: "user-video"
  }, {
    path: "/user/viewpoint",
    component: _782a3c18,
    alias: "/user/viewpoint/index.html",
    name: "user-viewpoint"
  }, {
    path: "/video/detail",
    component: _c206e48c,
    alias: "/video/detail/index.html",
    name: "video-detail"
  }, {
    path: "/businessIntelligence/agent/Detail",
    component: _06344c65,
    alias: "/businessIntelligence/agent/Detail/index.html",
    name: "businessIntelligence-agent-Detail"
  }, {
    path: "/businessIntelligence/invest/CityDetail",
    component: _6dbb7b52,
    alias: "/businessIntelligence/invest/CityDetail/index.html",
    name: "businessIntelligence-invest-CityDetail"
  }, {
    path: "/businessIntelligence/invest/DeepDetail",
    component: _33cb9cda,
    alias: "/businessIntelligence/invest/DeepDetail/index.html",
    name: "businessIntelligence-invest-DeepDetail"
  }, {
    path: "/businessIntelligence/invest/IndustryDetail",
    component: _f0409df6,
    alias: "/businessIntelligence/invest/IndustryDetail/index.html",
    name: "businessIntelligence-invest-IndustryDetail"
  }, {
    path: "/businessIntelligence/tender/Detail",
    component: _394d4ae6,
    alias: "/businessIntelligence/tender/Detail/index.html",
    name: "businessIntelligence-tender-Detail"
  }, {
    path: "/businessIntelligence/thematic/Detail",
    component: _30f81afb,
    alias: "/businessIntelligence/thematic/Detail/index.html",
    name: "businessIntelligence-thematic-Detail"
  }, {
    path: "/deal-nav/config/rate",
    component: _82a3522e,
    alias: "/deal-nav/config/rate/index.html",
    name: "deal-nav-config-rate"
  }, {
    path: "/deal-nav/seciton/deal-center-info",
    component: _49ecffe8,
    alias: "/deal-nav/seciton/deal-center-info/index.html",
    name: "deal-nav-seciton-deal-center-info"
  }, {
    path: "/deal-nav/seciton/main-bottom",
    component: _6e9091c8,
    alias: "/deal-nav/seciton/main-bottom/index.html",
    name: "deal-nav-seciton-main-bottom"
  }, {
    path: "/deal-nav/seciton/main-center",
    component: _181c9ef2,
    alias: "/deal-nav/seciton/main-center/index.html",
    name: "deal-nav-seciton-main-center"
  }, {
    path: "/search/config/nav",
    component: _a9752c70,
    alias: "/search/config/nav/index.html",
    name: "search-config-nav"
  }, {
    path: "/search/mixins/main",
    component: _f93bfd0c,
    alias: "/search/mixins/main/index.html",
    name: "search-mixins-main"
  }, {
    path: "/user/assets/explain",
    component: _73cff557,
    alias: "/user/assets/explain/index.html",
    name: "user-assets-explain"
  }, {
    path: "/user/assets/vip",
    component: _4cb84d06,
    alias: "/user/assets/vip/index.html",
    name: "user-assets-vip"
  }, {
    path: "/library/assets/js/news",
    component: _721022f2,
    alias: "/library/assets/js/news/index.html",
    name: "library-assets-js-news"
  }, {
    path: "/notice/assets/js/news",
    component: _40f21676,
    alias: "/notice/assets/js/news/index.html",
    name: "notice-assets-js-news"
  }, {
    path: "/polymerize/assets/js/news",
    component: _511abf08,
    alias: "/polymerize/assets/js/news/index.html",
    name: "polymerize-assets-js-news"
  }, {
    path: "/user/assets/icon/coin",
    component: _3b4581cc,
    alias: "/user/assets/icon/coin/index.html",
    name: "user-assets-icon-coin"
  }, {
    path: "/user/assets/icon/score",
    component: _162297d9,
    alias: "/user/assets/icon/score/index.html",
    name: "user-assets-icon-score"
  }, {
    path: "/user/assets/icon/ticket",
    component: _62172456,
    alias: "/user/assets/icon/ticket/index.html",
    name: "user-assets-icon-ticket"
  }, {
    path: "/user/assets/icon/ticket-special",
    component: _196a2ec1,
    alias: "/user/assets/icon/ticket-special/index.html",
    name: "user-assets-icon-ticket-special"
  }, {
    path: "/user/assets/icon/wechat",
    component: _958e1e22,
    alias: "/user/assets/icon/wechat/index.html",
    name: "user-assets-icon-wechat"
  }, {
    path: "/user/message/mixins/item",
    component: _bdafbd00,
    alias: "/user/message/mixins/item/index.html",
    name: "user-message-mixins-item"
  }, {
    path: "/user/message/mixins/list",
    component: _2dddfc15,
    alias: "/user/message/mixins/list/index.html",
    name: "user-message-mixins-list"
  }, {
    path: "/user/assets/icon/mixins/main",
    component: _ce80ba8a,
    alias: "/user/assets/icon/mixins/main/index.html",
    name: "user-assets-icon-mixins-main"
  }, {
    path: "/qa/special/:guid?",
    component: _591947a1,
    alias: "/qa/special/:guid?/index.html",
    name: "qa-special-guid"
  }, {
    path: "/viewpoint/topic/:id?",
    component: _753400e4,
    alias: "/viewpoint/topic/:id?/index.html",
    name: "viewpoint-topic-id"
  }, {
    path: "/article/:guid",
    component: _e2c0d298,
    alias: "/article/:guid/index.html",
    name: "article-guid"
  }, {
    path: "/document/:guid",
    component: _61cac8db,
    alias: "/document/:guid/index.html",
    name: "document-guid"
  }, {
    path: "/library/:guid",
    component: _36cfbc62,
    alias: "/library/:guid/index.html",
    name: "library-guid"
  }, {
    path: "/qa/:guid",
    component: _072a4946,
    alias: "/qa/:guid/index.html",
    name: "qa-guid"
  }, {
    path: "/video/:guid",
    component: _944ce6e2,
    alias: "/video/:guid/index.html",
    name: "video-guid"
  }, {
    path: "/viewpoint/:guid",
    component: _9c687002,
    alias: "/viewpoint/:guid/index.html",
    name: "viewpoint-guid"
  }, {
    path: "/",
    component: _c8146780,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "compoentsNew/dishonesty-name",
      component: _ec5ae5b8,
      name: "index-compoentsNew-dishonesty-name"
    }, {
      path: "compoentsNew/hot-new",
      component: _e0f0a090,
      name: "index-compoentsNew-hot-new"
    }, {
      path: "compoentsNew/intelligent-answers",
      component: _c3815192,
      name: "index-compoentsNew-intelligent-answers"
    }, {
      path: "compoentsNew/latest-answers",
      component: _211c4e47,
      name: "index-compoentsNew-latest-answers"
    }, {
      path: "compoentsNew/library-box",
      component: _10658e5e,
      name: "index-compoentsNew-library-box"
    }, {
      path: "compoentsNew/notice-publicity",
      component: _a3d482f0,
      name: "index-compoentsNew-notice-publicity"
    }, {
      path: "compoentsNew/policy-regulatory",
      component: _8ef91faa,
      name: "index-compoentsNew-policy-regulatory"
    }, {
      path: "compoentsNew/popular-searches",
      component: _45ef7162,
      name: "index-compoentsNew-popular-searches"
    }, {
      path: "compoentsNew/puishment-demo",
      component: _2e4c3dd1,
      name: "index-compoentsNew-puishment-demo"
    }, {
      path: "compoentsNew/standard-specification",
      component: _df3a4bea,
      name: "index-compoentsNew-standard-specification"
    }, {
      path: "compoentsNew/swiper",
      component: _bbf213e0,
      name: "index-compoentsNew-swiper"
    }, {
      path: "compoentsNew/tool-box",
      component: _6c965eae,
      name: "index-compoentsNew-tool-box"
    }, {
      path: "compoentsNew/video-box",
      component: _83b0aede,
      name: "index-compoentsNew-video-box"
    }, {
      path: "assets/js/news",
      component: _501ec150,
      name: "index-assets-js-news"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
